


import { Filter, Printer } from "lucide-react";

export default function FiltroFechas({
    setFechaDesde,
    setFechaHasta,
    fechaHasta,
    fechaDesde,
    handleFiltrarClick,
    estadoImprimir,
    handleImprimirClick
}) {

    const handleChangeFechaVtoDesde = (e) => setFechaDesde(e.target.value);
    const handleChangeFechaVtoHasta = (e) => setFechaHasta(e.target.value);

    return (
        <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-4 py-0 px-3 md:px-4  mb-0">

            {/* CONTENEDOR DE FECHAS: Se ajusta a 2 columnas en mobile, 1 fila en desktop */}
            <div className="flex flex-row items-center gap-4 md:gap-6">

                {/* FECHA DESDE */}
                <div className="flex items-center gap-2">
                    <label htmlFor="desde" className="text-[#221a05] text-[10px] font-black tracking-widest uppercase">
                        Desde
                    </label>
                    <input
                        value={fechaDesde}
                        id="desde"
                        type="date"
                        onChange={handleChangeFechaVtoDesde}
                        className="bg-gray-50 text-[#050f08] text-[11px] font-bold rounded-lg py-1 px-2 border border-gray-300 focus:outline-none focus:border-[#c9a84c] transition-all cursor-pointer w-[125px] md:w-auto"
                    />
                </div>

                {/* FECHA HASTA */}
                <div className="flex items-center gap-2">
                    <label htmlFor="hasta" className="text-[#2b2105] text-[10px] font-black tracking-widest uppercase">
                        Hasta
                    </label>
                    <input
                        value={fechaHasta}
                        id="hasta"
                        type="date"
                        onChange={handleChangeFechaVtoHasta}
                        className="bg-gray-50 text-[#050f08] text-[11px] font-bold rounded-lg py-1 px-2 border border-gray-300 focus:outline-none focus:border-[#c9a84c] transition-all cursor-pointer w-[125px] md:w-auto"
                    />
                </div>
            </div>

            {/* DIVISOR: Solo visible en PC */}
            <div className="hidden md:block w-px h-6 bg-gray-200"></div>

            {/* BOTONES: Alineados al final en mobile, seguidos en PC */}
            <div className="flex items-center gap-3 border-t border-gray-100 pt-2 md:border-none md:pt-0 w-full md:w-auto justify-center">
                <button
                    type="button"
                    title='Filtrar'
                    onClick={handleFiltrarClick}
                    className="flex items-center gap-2 md:gap-0 p-2 md:p-1.5 rounded-lg bg-[#050f08] text-white hover:bg-[#c9a84c] transition-all active:scale-95 shadow-md"
                >
                    <Filter size={16} />
                    <span className="md:hidden text-[10px] font-black uppercase tracking-widest">Filtrar</span>
                </button>

                <button
                    type="button"
                    title="Imprimir"
                    onClick={handleImprimirClick}
                    disabled={!estadoImprimir}
                    className={`flex items-center gap-2 md:gap-0 p-2 md:p-1.5 rounded-lg border transition-all active:scale-95 shadow-sm
                        ${!estadoImprimir
                            ? 'bg-gray-50 text-gray-300 border-gray-200 cursor-not-allowed opacity-50'
                            : 'bg-white text-[#050f08] border-gray-300 hover:bg-gray-100 hover:border-[#050f08]'
                        }`}
                >
                    <Printer size={16} />
                    <span className="md:hidden text-[10px] font-black uppercase tracking-widest">Imprimir</span>
                </button>
            </div>
        </div>
    );
}